var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import useTranslate from '../../../../../localization/helpers';
import MonteurLogo from '../../../../icons/components/monteur-log';
var ChatPDF = function (_a) {
    var messages = _a.messages, documents = _a.documents, machineName = _a.machineName, userName = _a.userName, conversationName = _a.conversationName;
    var translate = useTranslate().translate;
    var groupedMessages = useMemo(function () {
        return messages.reduce(function (groups, conversation) {
            var groupKey = new Date(conversation.time).toDateString();
            if (!groups[groupKey])
                groups[groupKey] = [];
            groups[groupKey].push(conversation);
            return groups;
        }, {});
    }, [messages]);
    var subHeader = {
        fontWeight: 600,
        fontSize: '24px !important'
    };
    var chat = {
        fontWeight: 400,
        fontSize: '14px'
    };
    var line = {
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        color: '#333',
        marginBottom: '12px'
    };
    var lineBefore = {
        content: '""',
        flex: 1,
        borderBottom: '1px solid #ccc',
        marginRight: '10px'
    };
    var lineAfter = {
        content: '""',
        flex: 1,
        borderBottom: '1px solid #ccc',
        marginLeft: '10px'
    };
    return (_jsxs("div", { children: [_jsxs("div", { style: {
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row'
                }, children: [_jsx("h2", { style: {
                            flexBasis: '95%',
                            color: '#009983',
                            fontWeight: 700,
                            fontSize: '36px',
                            padding: 0,
                            margin: 0
                        }, children: translate('chat.monteurChat') }), _jsx("div", { style: { flexBasis: '5%' }, children: _jsx(MonteurLogo, {}) })] }), _jsxs("div", { style: { marginTop: '12px', display: 'flex', flexDirection: 'column', width: '100%' }, children: [_jsxs("h2", { style: subHeader, children: [" ", translate('common.asset')] }), _jsx("div", { style: {
                            padding: '16px',
                            border: '2px solid #ccc',
                            borderRadius: '12px'
                        }, children: _jsx("p", { style: { margin: 0 }, children: machineName }) })] }), _jsxs("div", { style: { marginTop: '12px' }, children: [_jsx("h2", { style: subHeader, children: translate('chat.chatInformation') }), _jsxs("div", { style: { display: 'flex', flexDirection: 'row' }, children: [_jsxs("div", { style: {
                                    flexBasis: '48%',
                                    padding: '10px',
                                    border: '2px solid #ccc',
                                    borderRadius: '12px'
                                }, children: [_jsx("div", { style: { fontWeight: 'bold', marginBottom: '8px' }, children: translate('common.chatBy') }), _jsx("div", { children: userName })] }), _jsx("div", { style: { flexBasis: '4%' } }), _jsxs("div", { style: {
                                    flexBasis: '48%',
                                    padding: '10px',
                                    border: '2px solid #ccc',
                                    borderRadius: '12px'
                                }, children: [_jsx("div", { style: { fontWeight: 'bold', marginBottom: '8px' }, children: translate('chat.dateTime') }), _jsx("div", { children: new Date(messages[0].time).toLocaleDateString(translate('common.dateLanguageCode1'), {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric'
                                        }) })] })] })] }), _jsxs("div", { style: { marginTop: '12px' }, children: [_jsx("h2", { style: subHeader, children: conversationName }), _jsx("div", { style: { display: 'block' }, children: Object.entries(groupedMessages).map(function (_a) {
                            var _b = __read(_a, 2), date = _b[0], messages = _b[1];
                            return (_jsxs("div", { children: [_jsxs("div", { style: line, children: [_jsx("span", { style: lineBefore }), new Date(date).toLocaleDateString(translate('common.dateLanguageCode1'), {
                                                year: 'numeric',
                                                month: 'long',
                                                day: 'numeric'
                                            }), _jsx("span", { style: lineAfter })] }), messages.map(function (message) { return (_jsxs("div", { style: { marginBottom: '24px' }, children: [message.question && (_jsx("div", { style: {
                                                    display: 'flex',
                                                    justifyContent: 'flex-end'
                                                }, children: _jsxs("div", { style: {
                                                        backgroundColor: '#B4964014',
                                                        padding: '10px',
                                                        borderRadius: '8px'
                                                    }, children: [_jsx("p", { style: __assign({ padding: 0, margin: 0 }, chat), children: message.question }), _jsx("p", { style: {
                                                                padding: 0,
                                                                margin: 0,
                                                                fontSize: '12px',
                                                                color: 'gray',
                                                                textAlign: 'right'
                                                            }, children: new Date(message.time).toLocaleTimeString(translate('common.dateLanguageCode1'), {
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                hour12: true
                                                            }) })] }) })), _jsx("div", { style: {
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    marginTop: '12px',
                                                    marginBottom: '12px'
                                                }, children: _jsxs("div", { style: {
                                                        backgroundColor: '#00937E14',
                                                        padding: '10px',
                                                        borderRadius: '8px'
                                                    }, children: [_jsx("div", { style: { fontSize: '14px' }, children: _jsx(ReactMarkdown, { rehypePlugins: [rehypeRaw, remarkGfm], children: message.answer }) }), message.sources &&
                                                            documents.map(function (doc) {
                                                                var matchedDocuments = message.sources.filter(function (d) { return d.document === doc.fileName; });
                                                                if (matchedDocuments.length) {
                                                                    return (_jsxs(Fragment, { children: [_jsx("p", { style: {
                                                                                    padding: 0,
                                                                                    margin: 1,
                                                                                    fontSize: '12px',
                                                                                    color: 'gray',
                                                                                    borderTop: '1px solid #919EAB33'
                                                                                } }), _jsxs("p", { style: {
                                                                                    fontWeight: 400,
                                                                                    fontSize: '10px',
                                                                                    marginTop: 1,
                                                                                    color: '#555555'
                                                                                }, children: [_jsx("strong", { children: doc.title }), ", ".concat(doc.fileName, " (pg: ").concat(matchedDocuments.flatMap(function (x) { return x.page; }).join(', '), ")")] }, doc.fileName)] }, doc.id));
                                                                }
                                                                return null;
                                                            }), _jsx("p", { style: {
                                                                padding: 0,
                                                                margin: 0,
                                                                fontSize: '12px',
                                                                color: 'gray',
                                                                textAlign: 'right'
                                                            }, children: new Date(message.time).toLocaleTimeString(translate('common.dateLanguageCode1'), {
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                hour12: true
                                                            }) })] }) })] }, message.message_id)); })] }, date));
                        }) })] })] }));
};
export default ChatPDF;
